import FlexCutoff from './components/FlexCutoff.vue'
import FlexLeaderboard from './components/FlexLeaderboard.vue'
import EmisiaView from './components/Emisia/EmisiaView.vue'
import EmisiaHome from './components/Emisia/EmisiaHome.vue'
import EggTimer from './components/Emisia/EggTimer.vue'
import ComplimentView from './components/Emisia/ComplimentView.vue'
import HomeView from './components/HomeView.vue'
import VueRouter from "vue-router";
import Vue from 'vue';

Vue.use(VueRouter)

const routes = [
    {path: '/', component: HomeView, name: 'Kuźnia FLEX'},
    {path: '/cutoff', component: FlexCutoff, name: 'Kuźnia FLEX - Cutoff'},
    {path: '/leaderboard', component: FlexLeaderboard, name: 'Kuźnia FLEX - Leaderboard'},
    {
        path: '/emisia', component: EmisiaView, name: 'Emisiowo', children: [
            {path: '', component: EmisiaHome, name: 'Emisiowo'},
            {path: 'jajeczko', component: EggTimer, name: 'Emisiowo - Jajeczko'},
            {path: 'uwu', component: ComplimentView, name: 'Emisiowo - UwU'},
        ]
    },
]

export default new VueRouter({
    mode: 'history',
    routes,
});
